export const LIST_BMI_CRITERIA_REQUEST = 'LIST_BMI_CRITERIA_REQUEST'
export const LIST_BMI_CRITERIA_SUCCESS = 'LIST_BMI_CRITERIA_SUCCESS'
export const LIST_BMI_CRITERIA_FAIL = 'LIST_BMI_CRITERIA_FAIL'

export const LIST_BMI_CRITERIA_SUMMARY_REQUEST = 'LIST_BMI_CRITERIA_SUMMARY_REQUEST'
export const LIST_BMI_CRITERIA_SUMMARY_SUCCESS = 'LIST_BMI_CRITERIA_SUMMARY_SUCCESS'
export const LIST_BMI_CRITERIA_SUMMARY_FAIL = 'LIST_BMI_CRITERIA_SUMMARY_FAIL'

export const CREATE_BMI_CRITERIA_REQUEST = 'CREATE_BMI_CRITERIA_REQUEST'
export const CREATE_BMI_CRITERIA_SUCCESS = 'CREATE_BMI_CRITERIA_SUCCESS'
export const CREATE_BMI_CRITERIA_FAIL = 'CREATE_BMI_CRITERIA_FAIL'

export const DETAIL_BMI_CRITERIA_REQUEST = 'DETAIL_BMI_CRITERIA_REQUEST'
export const DETAIL_BMI_CRITERIA_SUCCESS = 'DETAIL_BMI_CRITERIA_SUCCESS'
export const DETAIL_BMI_CRITERIA_FAIL = 'DETAIL_BMI_CRITERIA_FAIL'

export const UPDATE_BMI_CRITERIA_REQUEST = 'UPDATE_BMI_CRITERIA_REQUEST'
export const UPDATE_BMI_CRITERIA_SUCCESS = 'UPDATE_BMI_CRITERIA_SUCCESS'
export const UPDATE_BMI_CRITERIA_FAIL = 'UPDATE_BMI_CRITERIA_FAIL'

export const UPDATE_BMI_CRITERIA_DEFAULT_REQUEST = 'UPDATE_BMI_CRITERIA_DEFAULT_REQUEST'
export const UPDATE_BMI_CRITERIA_DEFAULT_SUCCESS = 'UPDATE_BMI_CRITERIA_DEFAULT_SUCCESS'
export const UPDATE_BMI_CRITERIA_DEFAULT_FAIL = 'UPDATE_BMI_CRITERIA_DEFAULT_FAIL'

export const DELETE_BMI_CRITERIA_REQUEST = 'DELETE_BMI_CRITERIA_REQUEST'
export const DELETE_BMI_CRITERIA_SUCCESS = 'DELETE_BMI_CRITERIA_SUCCESS'
export const DELETE_BMI_CRITERIA_FAIL = 'DELETE_BMI_CRITERIA_FAIL'

export const RESET_BMI_CRITERIA = 'RESET_BMI_CRITERIA'

export const SUMMARY_WA_TEMPLATES_REQUEST = 'SUMMARY_WA_TEMPLATES_REQUEST'
export const SUMMARY_WA_TEMPLATES_SUCCESS = 'SUMMARY_WA_TEMPLATES_SUCCESS'
export const SUMMARY_WA_TEMPLATES_FAIL = 'SUMMARY_WA_TEMPLATES_FAIL'